import { render, staticRenderFns } from "./studentEdit.vue?vue&type=template&id=74e94622&scoped=true&"
import script from "./studentEdit.vue?vue&type=script&lang=js&"
export * from "./studentEdit.vue?vue&type=script&lang=js&"
import style0 from "./studentEdit.vue?vue&type=style&index=0&id=74e94622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e94622",
  null
  
)

export default component.exports